<form [formGroup]="cycleDetails" id="cycle-details" (ngSubmit)=onSubmit(cycleDetails)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container-fluid"
		[ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion"
			(editQuestionChange)="editQuestionChange($event)">
			<!-- both: cycle propose-->
			<question [qID]="'1'">
				<h3>{{'CYCLE_DETAILS.Q1.QUESTION'|translate }}</h3>
				<div class="mt-4">
					<box-selector formControlName="cyclePurpose" [options]="optionsPurpose"
						[(selectedOption)]="selectedOptionPurpose" (optionClicked)="onSubmit(cycleDetails)">
					</box-selector>
				</div>
			</question>
			<!--both: cycle amount-->
			<question [qID]="'2'">
				<div>
					<h3>
						<inner-tooltip [qTitle]="'CYCLE_DETAILS.Q2.QUESTION'|translate"
							[text]="'CYCLE_DETAILS.Q1.TOOLTIP_TEXT'|translate" class="m-inner-popover"></inner-tooltip>
					</h3>
					<div class="mx-1 form-group">
						<input formControlName="cycleAmount" class="m-form-control form-control" currencyMask type="tel"
							placeholder="{{'CYCLE_DETAILS.Q2.PH1'|translate}}">
						<div class="form-text m-error"
							*ngIf="cycleDetails.get('cycleAmount').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='2'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--internal: yes no q advisor -->
			<question [qID]="'2-0'">
				<h3>{{"CYCLE_DETAILS.Q2-0.QUESTION"|translate}}</h3>
				<div class="btn-group-toggle" data-toggle="buttons">
					<label class="btn btn-primary"
						[ngClass]="{'selected':cycleDetails.get('isHigherThanTheExistingOne').value==='YES'}">
						{{"COMMON.YES"|translate}}
						<input type="radio" formControlName="isHigherThanTheExistingOne" value="YES"
							(change)="onSubmit(cycleDetails)" click2change>
					</label>
					<label class="btn btn-primary"
						[ngClass]="{'selected':cycleDetails.get('isHigherThanTheExistingOne').value==='NO'}">
						{{"COMMON.NO"|translate}}
						<input type="radio" formControlName="isHigherThanTheExistingOne" value="NO"
							(change)="onSubmit(cycleDetails)" click2change>
					</label>
				</div>
			</question>
			<!-- cycle mixture -->
			<question [qID]="'2-1'">
				<h3>{{'CYCLE_DETAILS.Q2-1.QUESTION'|translate}}</h3>
				<div class="mx-1 form-group">
					<app-cycle-mixture (onAddFormGroup)="setValidatorsArray()" (onFormChange)="setValidatorsArray()"
						[displayErrors]="submitted" [cycleMixureFormArray]="cycleDetails.get('cycleMixture')">
					</app-cycle-mixture>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='2-1'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--exteranl: banks list -->
			<question [qID]="'3'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q3.QUESTION"|translate}}</h3>
					<div class="mx-1 form-group">
						<input type="text" placeholder="{{'CYCLE_DETAILS.Q3.PH1'|translate}}" aria-label="Number"
							(input)="onSearchBankChange($event.target.value)" formControlName="externalBank"
							[formControl]="externalBank" [matAutocomplete]="autoBank"
							class="form-control m-form-control2">
						<mat-autocomplete #autoBank="matAutocomplete">
							<mat-option *ngFor="let bank of banksFilterList | async" [value]="bank.mtext">
								{{bank.mtext}}
							</mat-option>
						</mat-autocomplete>
						<div class="m-error form-text"
							*ngIf="cycleDetails.get('externalBank').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
						<div class="m-error form-text"
							*ngIf="cycleDetails.get('externalBank').hasError('pattern') && submitted">
							<div *ngFor="let bank of banksFilterList | async">
								<div *ngIf="checkBankchoose(bank.name,cycleDetails.get('externalBank').value)">
								</div>
							</div>
							<div *ngIf="checkBank == 0">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
						<div class="m-error form-text"
							*ngIf="cycleDetails.get('externalBank').hasError('isNotInBankList') && !cycleDetails.get('externalBank').hasError('required') && submitted">
							{{'COMMON.NOT_IN_LIST_ERROR' | translate}}
						</div>
					</div>
					<div class="d-flex justify-content-center">
						<button type="submit" class="btn btn-primary"
							[ngClass]="{'m-valid' : cycleDetails.valid && qID=='3'}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>
			<!--exteranl: mortgage makor propose -->
			<question [qID]="'4'">
				<h3>{{'CYCLE_DETAILS.Q4.QUESTION'|translate }}</h3>
				<div class="mx-1 form-group">
					<input type="text" placeholder="{{'CYCLE_DETAILS.Q4.PH1'|translate}}" aria-label="Number"
						(input)="onSearchProposeMakorChange($event.target.value)" formControlName="externalMakorPropose"
						[formControl]="externalMakorPropose" [matAutocomplete]="autoMakorPropose"
						class="form-control m-form-control2">
					<mat-autocomplete #autoMakorPropose="matAutocomplete">
						<mat-option *ngFor="let prop of optionsMakorPurposeFilterList | async" [value]="prop.label">
							{{prop.label}}
						</mat-option>
					</mat-autocomplete>
					<div class="m-error form-text"
						*ngIf="cycleDetails.get('externalMakorPropose').hasError('required') && submitted">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error form-text"
						*ngIf="cycleDetails.get('externalMakorPropose').hasError('pattern') && submitted">
						<div *ngFor="let prop of optionsMakorPurposeFilterList | async">
							<div
								*ngIf="checkProposeMakorchoose(prop.label,cycleDetails.get('externalMakorPropose').value)">
							</div>
						</div>
						<div *ngIf="checkProposeMakor == 0">
							{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='4'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--exteranl: mortgage balance -->
			<question [qID]="'5'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q5.QUESTION"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="externalMortgageBalance" class="m-form-control form-control"
							currencyMask type="tel" placeholder="{{'CYCLE_DETAILS.Q5.PH1'|translate}}">
						<div class="form-text m-error"
							*ngIf="cycleDetails.get('externalMortgageBalance').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='5'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--exteranl: monthly repayment -->
			<question [qID]="'6'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q6.QUESTION"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="externalMonthlyRepayment" class="m-form-control form-control"
							currencyMask type="tel" placeholder="{{'CYCLE_DETAILS.Q6.PH1'|translate}}">
						<div class="form-text m-error"
							*ngIf="cycleDetails.get('externalMonthlyRepayment').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='6'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--exteranl: cities list -->
			<question [qID]="'7'">
				<h3>{{'CYCLE_DETAILS.Q7.QUESTION'|translate}}</h3>
				<div class="mx-1 form-group">
					<input type="text" placeholder="{{'CYCLE_DETAILS.Q7.PH1'|translate}}" aria-label="Number" matInput
						formControlName="inWhichCity" [formControl]="inWhichCity" [matAutocomplete]="autoCity"
						class="m-form-control form-control">
					<mat-autocomplete #autoCity="matAutocomplete">
						<mat-option *ngFor="let city of  cityFilterList | async" [value]="city.name">
							{{ city.name }}
						</mat-option>
					</mat-autocomplete>


					<div class="m-error form-text"
						*ngIf="cycleDetails.get('inWhichCity').hasError('required') && submitted">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error form-text"
						*ngIf="cycleDetails.get('inWhichCity').hasError('isNotInCityList') && !cycleDetails.get('inWhichCity').hasError('required') && submitted">
						{{'COMMON.NOT_IN_LIST_ERROR' | translate}}
					</div>

				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='7'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>

			</question>
			<!--exteranl: monthly repayment -->
			<question [qID]="'8'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q8.QUESTION"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="externalValueOfProperty" class="m-form-control form-control"
							currencyMask type="tel" placeholder="{{'CYCLE_DETAILS.Q8.PH1'|translate}}">
						<div class="form-text m-error"
							*ngIf="cycleDetails.get('externalValueOfProperty').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='8'}">
						{{"COMMON.PROCEED"|translate}}
					</button>
				</div>
			</question>

			<!--internal: yes no q cycle all -->
			<question [qID]="'9'">
				<h3>{{"CYCLE_DETAILS.Q9.QUESTION"|translate}}</h3>
				<div class="btn-group-toggle" data-toggle="buttons">
					<label class="btn btn-primary"
						[ngClass]="{'selected':cycleDetails.get('internalAreCycleAllMorygage').value==='YES'}">
						{{"COMMON.YES"|translate}}
						<input type="radio" formControlName="internalAreCycleAllMorygage" value="YES"
							(change)="onSubmit(cycleDetails)" click2change>
					</label>
					<label class="btn btn-primary"
						[ngClass]="{'selected':cycleDetails.get('internalAreCycleAllMorygage').value==='NO'}">
						{{"COMMON.NO"|translate}}
						<input type="radio" formControlName="internalAreCycleAllMorygage" value="NO"
							(change)="onSubmit(cycleDetails)" click2change>
					</label>
				</div>
			</question>
			<!--internal: input amount -->
			<question [qID]="'9-1'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q9-1.QUESTION"|translate}}</h3>
					<div class="mx-1 form-group">
						<input formControlName="internalCycleAmount" class="m-form-control form-control" currencyMask
							type="tel" placeholder="{{'CYCLE_DETAILS.Q9-1.PH1'|translate}}">
						<div class="form-text m-error"
							*ngIf="cycleDetails.get('internalCycleAmount').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='9-1'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--internal: input tik -->
			<question [qID]="'9-2'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q9-2.QUESTION"|translate}}</h3>
					<h5>{{"CYCLE_DETAILS.Q9-2.MESSAGE"|translate}}</h5>
					<div>
						<a [routerLink]="" (click)="openSite(1)">{{"CYCLE_DETAILS.Q9-2.LINK1"|translate}}</a>
					</div>
					<div>
						<a [routerLink]="" (click)="openSite(2)">{{"CYCLE_DETAILS.Q9-2.LINK2"|translate}}</a>
					</div>
					<div class="d-flex justify-content-center">
						<div class="pt-2 col-md-4 col-sm-6">
							<app-internal-tik-num-array formArrayName="internalTikNum"
								(onAddFormGroup)="setValidatorsArray()" (onTikNumChange)="setValidatorsArray()"
								[tiknumFormArray]="cycleDetails.get('internalTikNum')" [displayErrors]="submitted"
								[titles]="['CYCLE_DETAILS.Q9-2.QUESTION']" [ph]="['CYCLE_DETAILS.Q9-2.PH1']"
								[buttons]="['CYCLE_DETAILS.Q9-2.ADDBTN']">
							</app-internal-tik-num-array>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='9-2'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--internal: input maslol -->
			<question [qID]="'9-3'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q9-3.QUESTION"|translate}}</h3>
					<h5>{{"CYCLE_DETAILS.Q9-2.MESSAGE"|translate}}</h5>
					<div>
						<a [routerLink]="" (click)="openSite(1)">{{"CYCLE_DETAILS.Q9-2.LINK1"|translate}}</a>
					</div>
					<div>
						<a [routerLink]="" (click)="openSite(2)">{{"CYCLE_DETAILS.Q9-2.LINK2"|translate}}</a>
					</div>
					<div class="d-flex justify-content-center">
						<div class="pt-2 col-md-4 col-sm-6">
							<app-internal-maslol-array formArrayName="internalMaslol"
								(onAddFormGroup)="setValidatorsArray()" (onMaslolChange)="setValidatorsArray()"
								[internalMaslolArray]="cycleDetails.get('internalMaslol')" [displayErrors]="submitted"
								[titles]="['CYCLE_DETAILS.Q9-3.QUESTION']" [ph]="['CYCLE_DETAILS.Q9-3.PH1']"
								[buttons]="['CYCLE_DETAILS.Q9-3.ADDBTN']">
							</app-internal-maslol-array>
						</div>
					</div>
					<!-- <div class="pt-2">
						<input class="form-control m-form-control" type="tel"
							placeholder="{{'CYCLE_DETAILS.Q9-3.PH1'|translate}}" formControlName="internalMaslol" />
						<div>
							<div class="form-text m-error"
								*ngIf="cycleDetails.get('internalMaslol').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="cycleDetails.get('internalMaslol').hasError('pattern') && submitted">
								{{ 'COMMON.NUMBER' | translate }}
							</div>
						</div>
					</div> -->
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='9-3'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
			<!--internal: select product -->
			<!-- <question [qID]="'9-4'">
				<div>
					<h3>{{"CYCLE_DETAILS.Q9-4.QUESTION"|translate}}</h3>
					<div class="">
						<div class="form-group">
							<select formControlName="internalProduct" class="form-control m-form-control"
								[attr.aria-label]="'CYCLE_DETAILS.Q9-4.PH1'|translate">
								<option [value]="defaultValue">{{"CYCLE_DETAILS.Q9-4.PH1"|translate}}</option>
								<option *ngFor="let status of productsList" [value]="status">{{status}}</option>
							</select>
							<small class="m-error form-text"
								*ngIf="cycleDetails.get('internalProduct').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</small>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='9-4'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question> -->
			<!-- continue branch ext -->
			<question [qID]="'10'">
				<h3>{{'CYCLE_DETAILS.Q10.QUESTION'|translate}}</h3>
				<div class="mx-1 form-group">
					<!-- branch combos -->
					<select formControlName="continueBranch" class="form-control m-form-control"
						[attr.aria-label]="'CYCLE_DETAILS.Q9-4.PH1'|translate">
						<option [value]="defaultValue">{{"CYCLE_DETAILS.Q10.PH"|translate}}</option>
						<option *ngFor="let branch of branchList" [value]="branch.name">{{branch.name}}</option>
					</select>
					<small class="m-error form-text"
						*ngIf="cycleDetails.get('continueBranch').hasError('required') && submitted">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</small>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='10'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<!-- current account bank ext-->
			<question [qID]="'11'">
				<h3>{{'CYCLE_DETAILS.Q11.QUESTION'|translate}}</h3>
				<div class="mx-1 form-group">

					<!-- banks combo -->
					<select formControlName="oshBank" class="form-control m-form-control"
						[attr.aria-label]="'CYCLE_DETAILS.Q11.PH'|translate">
						<option [value]="defaultValue">{{"CYCLE_DETAILS.Q11.PH"|translate}}</option>
						<option *ngFor="let bank of banksList" [value]="bank.mtext">{{bank.mtext}}</option>
					</select>
					<small class="m-error form-text"
						*ngIf="cycleDetails.get('oshBank').hasError('required') && submitted">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</small>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : cycleDetails.valid && qID=='11'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>
		</questions-manager>
	</div>


// WEBPACK FOOTER //
// ./src/app/cycle-details/cycle-details.component.html